// const { baseURL } = require('@/config')
//baseUrl2调用的是wtbu_service中的方法
import { userInfoBaseURL } from '../config/net.config'
import request from '@/utils/request'
// import qs from 'qs'

/**
 *  根据传入code取到用户微信openID
 * @param data
 * @returns 
 */
export function getWxOpenId(data) {
    return request({
      url: userInfoBaseURL+'/wechatlogin',
      head: 'application/json;charset=UTF-8',
      method: 'post',
      data,
    })
} 
/**
 * 根据传入微信openID获取用户信息
 * @param {*} data 
 * @returns 
 */
export function getUserInfoByWxOpenId(data) {
  return request({
    url: userInfoBaseURL+'/wechatlogin/findWeChatOpenId',
    head: 'application/json;charset=UTF-8',
    method: 'post',
    data,
  })
} 
/**
 *  根据传入code取到用户企业微信openID
 * @param data
 * @returns 
 */
export function getQywxOpenId(data) {
  return request({
    url: userInfoBaseURL+'/QYWechatlogin',
    head: 'application/json;charset=UTF-8',
    method: 'post',
    data,
  })
} 
/**
* 根据传入企业微信openID获取用户信息
* @param {*} data 
* @returns 
*/
export function getUserInfoByQywxOpenId(data) {
return request({
  url: userInfoBaseURL+'/wechatlogin/findQYWeChatOpenId',
  head: 'application/json;charset=UTF-8',
  method: 'post',
  data,
})
} 
/**
 * 绑定用户openID
 * @param {*} data 
 * @returns 
 */
export function bindOpenId(data) {
  return request({
    url: userInfoBaseURL+'/wechatlogin/bindOpenId',
    head: 'application/json;charset=UTF-8',
    method: 'post',
    data,
  })
} 